<div class="container h-full flex flex-col mx-auto px-4 md:px-6 pt-8 pb-4">
  <div class="flex items-center mb-4 min-h-10">
    <h2 class="text-2xl font-medium">Sessies van XXX</h2>
  </div>

  <app-data-table-container>
    <table mat-table [dataSource]="dataSource()">
      <ng-container matColumnDef="startedAt">
        <th mat-header-cell *matHeaderCellDef>Gestart op</th>
        <td mat-cell *matCellDef="let element">
          {{ element.startedAt | date: 'MMMM dd, yyyy HH:mm' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="endedAt">
        <th mat-header-cell *matHeaderCellDef>Geëindigd op</th>
        <td mat-cell *matCellDef="let element">
          {{ element.endedAt | date: 'MMMM dd, yyyy HH:mm' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="duration">
        <th mat-header-cell *matHeaderCellDef>Duratie</th>
        <td mat-cell *matCellDef="let element">
          {{ element.duration }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element"></td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
        class="whitespace-nowrap"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="hover:!bg-gray-100 whitespace-nowrap"
      ></tr>

      <tr class="mat-mdc-row" *matNoDataRow>
        <td
          class="mat-mdc-cell mdc-data-table__cell !border-none"
          [colSpan]="displayedColumns.length"
        >
          Geen resultaten gevonden
        </td>
      </tr>
    </table>

    <mat-paginator
      class="border-t border-(--mat-table-row-item-outline-color)"
    ></mat-paginator>
  </app-data-table-container>
</div>
